import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { useEffect, useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ICON_TYPE } from "utils/constants";
import { trans } from "utils/helpers";

export const FormsNotification = () => {
  const [count, setCount] = useState<any>(false);
  const [flag, setFlag] = useState<boolean>(false);
  const details = useRef<any>("");
  const [showForm, setShowForm] = useState<any>(false);
  const deleteForm = (item) => {
    if (localStorage.getItem("unSavedData")) {
      let forms = JSON.parse(localStorage.getItem("unSavedData") as any) ?? {};
      if (forms) {
        delete forms[item];
        setCount(Object.keys(forms));
      } else {
        setCount([]);
      }
      if (Object.keys(forms)?.length > 0) {
        localStorage.setItem(
          "unSavedData",
          forms == null ? "" : JSON.stringify(forms)
        );
      } else {
        localStorage.removeItem("unSavedData");
      }
    }
  };

  const enterNavigat = (event) => {
    if (event.key == "Enter") {
      setShowForm(true);
    }
  };

  useEffect(() => {
    if (flag == true) {
      document.addEventListener("keydown", enterNavigat);
    }
    return () => {
      document.removeEventListener("keydown", enterNavigat);
    };
  }, [flag]);

  useEffect(() => {
    if (localStorage.getItem("unSavedData") != null) {
      let formstring: any = {};
      if (localStorage.getItem("unSavedData") + "") {
        formstring = localStorage.getItem("unSavedData") ?? {};
      }
      let forms = JSON.parse(formstring);
      if (forms) {
        let formsTitles = Object.keys(forms);
        details.current = forms;
        setCount(formsTitles);
      }
    }
  }, []);
  return (
    <>
      {showForm && (
        <ModalForm
          checkClose={false}
          mode={"edit"}
          modalProfileKey={"UnsavedForms"}
          title={trans("UnsavedForms")}
          onHide={() => {
            setShowForm(false);
          }}
          show={showForm}
        >
          <div className="card">
            <div className="card-body row">
              {count.length > 0 ? (
                count.map((item, index) => (
                  <div
                    style={{ width: "15%" }}
                    className="group-person__selected-option form-control-custom mx-1"
                    key={item + index}
                  >
                    <div
                      className="group-person__defult-selected-option"
                      data-key={item}
                    ></div>

                    <OverlayTrigger
                      key={item}
                      placement="top"
                      delay={{ show: 600, hide: 0 }}
                      overlay={
                        <Tooltip
                          className="tooltip "
                          id={`button-tooltip-${"item"}`}
                        >
                          {details.current?.[item]?.detailOfFormNotification
                            ? trans(item) +
                              " - " +
                              details.current?.[item]?.detailOfFormNotification
                            : trans(item)}
                        </Tooltip>
                      }
                    >
                      <div className="showDots">
                        {details.current?.[item]?.detailOfFormNotification
                          ? trans(item) +
                            " - " +
                            details.current?.[item]?.detailOfFormNotification
                          : trans(item)}
                      </div>
                    </OverlayTrigger>

                    <div
                      className="group-person__delete-selected-option"
                      data-key={item}
                      onClick={() => {
                        deleteForm(item);
                      }}
                    >
                      <FontAwesomeIcon icon={[ICON_TYPE, "times"]} />
                    </div>
                  </div>
                ))
              ) : (
                <Message message={"NoDataForPreview"} type={"info"} />
              )}
            </div>
          </div>
        </ModalForm>
      )}
      {count.length > 0 && (
        <li className="header-itemsIcons">
          <a
            href="#"
            onFocus={() => setFlag(true)}
            onBlur={() => setFlag(false)}
          >
            <div
              className="position-relative"
              onClick={(e) => {
                setShowForm(true);
              }}
            >
              <FontAwesomeIcon icon={[ICON_TYPE, "retweet"]} />
              {count.length > 0 ? (
                <span className="badgeCartable">
                  {count.length > 0
                    ? count.length > 99
                      ? "99+"
                      : count.length
                    : " "}
                </span>
              ) : (
                <></>
              )}
            </div>
          </a>
        </li>
      )}
    </>
  );
};
